var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12", attrs: { id: "overrides-msg" } }, [
    _c("div", [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "row justify-content-center p-4" }, [
          _c("div", { staticClass: "col-12 col-md-9" }, [
            _c("h5", { staticClass: "override-title font-weight-bold" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t(
                      "settings.turnOnBrokerageOverridesForApplicationFormAndDisclaimers"
                    )
                  ) +
                  "\n          "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "m-0 d-none d-sm-block" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("settings.changesMadeInThisPageWillAplyTo")) +
                  "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-3 col-lg-3 my-auto pretty-custom d-flex d-sm-block justify-content-end text-center",
            },
            [
              _c("div", { staticClass: "pretty p-bigger p-switch p-fill" }, [
                _c("label", { staticClass: "text-light-gray label-before" }, [
                  _vm._v(_vm._s(_vm.$t("global.words.no"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  attrs: { id: "switch", type: "checkbox" },
                  domProps: { checked: _vm.overrides.overrideForm },
                  on: { click: _vm.updateOverrides },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "d-none", attrs: { for: "switch" } },
                  [_vm._v(_vm._s(_vm.$t("global.words.switch")))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "state" }, [
                  _c("label", { staticClass: "regular" }, [
                    _vm._v(_vm._s(_vm.$t("global.words.yes"))),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }